import { useStore } from 'effector-react'

import {
  $totalCountOfTokensList,
  getTokensList,
  tokensListMounted,
  $tokensList,
} from './model'

export const useTokensList = () => {
  const tokensList = useStore($tokensList)
  const loading = useStore(getTokensList.pending)
  const totalCountOfTokensList = useStore($totalCountOfTokensList)

  const onChangeTokensList = ({
    limit,
    page,
    orderBy,
    orderDirection,
  }: any) => {
    tokensListMounted({
      limit,
      page,
      orderBy,
      orderDirection,
    })
  }

  return {
    tokensList,
    totalCountOfTokensList,
    loading,
    onChangeTokensList,
  }
}
